// ------------------------------------------------------
$(".mm__link.has-submenu").click(function (e) {
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).next(".mm-submenu").slideToggle();
});

$(".m-menu-drawer__tab-link").click(function (e) {
  e.preventDefault();
  $(".m-menu-drawer__tab-link").removeClass("active");
  $(this).addClass("active");
  $(".m-menu-drawer__tab-content").hide();

  var activeTab = $(this).attr("href");
  $(activeTab).fadeIn();
  return false;
});


  let descriptionShow = document.getElementById('description-show');
    let descriptionHideShow = document.getElementById('desp-hide-show');
    let isOpen = false;

    descriptionShow.addEventListener('click', function() {
        if (isOpen) {
            descriptionHideShow.style.maxHeight = '0';
            isOpen = false;
            descriptionShow.classList.remove('active');
        } else {
            descriptionHideShow.style.maxHeight = descriptionHideShow.scrollHeight + 'px';
            isOpen = true;
          descriptionShow.classList.add('active');
        }
    });